const clipboard = {
  getString: async () => '',
  setString: async () => {},
  hasString: async () => false,
};

export default clipboard;
export { clipboard };
